import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux'
import * as actions from '../../../store/actions'
import SearchCountChart from '../SearchCountChart'
import moment from 'moment';
import { useLocation, useNavigate } from 'react-router'
import {SearchHistoryCorrelation} from '../../../components' 

import { Dialog, DialogActions, DialogTitle, DialogContent, DialogContentText, Button, Divider, Grid, Chip, Typography } from '@mui/material';

const MerchantNotFoundDialog = props => {
  const { 
    openDialog,
    onCloseDialog,
    onChooseAdd,
    search,
    onFetchSearchCounts,
    search_counts,
    plan_level
  } = props;

  let navigate = useNavigate()
  
  const handleDialogClose = () => {
    onCloseDialog()
  };

  const handleChooseAdd = () => {
    onChooseAdd()
    navigate('/merchants/new')
  };

  const processData = (search_counts) => {
    let processedData = []
    let tempData = latestWins(search_counts)
    tempData = Object.values(tempData)
    // console.log('tempData', tempData)
    processedData = tempData.sort((a, b) => moment(a.created_at) - moment(b.created_at));

    // console.log('processedData', processedData)
    return processedData
  }

  const latestWins = (search_counts) => {
    let new_search_counts = {}
    for (var i=0; i < search_counts.length; i++){
      new_search_counts[search_counts[i].added_by_account_id] = search_counts[i];
    }

    // console.log('search_counts', search_counts)
    // console.log('new_search_counts', new_search_counts)
    return new_search_counts
  }

  useEffect(() => {
    if (is_fein(search)){
      onFetchSearchCounts(search)
    }
  }, [search])

  useEffect(() => {
    setProcessedSearchCounts(processData(search_counts))
  }, [search_counts])

  const [processed_search_counts, setProcessedSearchCounts] = useState([])

  const is_fein = (val) => {
    if (val && (val.length === 9 || val.length === 10)) {
      val = val.replace(/[^0-9]/, '')
      return val.length === 9
    } else {
      return false
    }
  };

  return (
    <Dialog
      open={openDialog}
      onClose={handleDialogClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth="maxWidth"
      maxWidth="xl"
    >
      <DialogTitle id="alert-dialog-title">{"No Merchants Found"}</DialogTitle>
      <Divider />
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          No merchants were found matching your search.  Would you llike to add a merchant into DataMerch?
        </DialogContentText>
        {processed_search_counts && processed_search_counts?.length > 0 && (plan_level === 'PRO') ?
          <DialogContentText id="alert-dialog-description2">
            <b>{search}</b> has been searched <b>{processed_search_counts.length}</b> times in the last six months.
            <br />
            <br />
            <SearchCountChart
              search_counts={processed_search_counts}
            />
          </DialogContentText>
        : null }
        {(plan_level !== 'PRO') ?
        <DialogContentText id="alert-dialog-description2">
          <br></br>
          <br></br>
          <Grid
            size={{xs:12, md:12}}
          >   
            <Chip label="Seach history is only available to PRO members." color="primary" />
            <br></br>
            <br></br>
          </Grid>
          <Grid
            size={{xs:12, md:12}}
          >
            <Typography variant="h6">
              Here's why search history matters:
            </Typography>
          </Grid>
          <Grid
            size={{xs:12, sm:12, lg: 12, xl:12}}
          >
            <SearchHistoryCorrelation />
          </Grid>
        </DialogContentText>
        : null }
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button onClick={handleDialogClose} color="primary">
          No
        </Button>
        <Button
          onClick={handleChooseAdd}
          variant="contained"
          color="primary"
          autoFocus
        >
          Yes, I want to add a merchant
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const mapStateToProps = state => {
  return {
    openDialog: state.merchant.merchant_not_found_dialog_open,
    search: state.merchant.search,
    search_counts: state.searchCount.search_counts,
    plan_level: state.auth.user.plan_level
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onCloseDialog: () => dispatch(actions.closeMerchantNotFoundDialog()),
    onChooseAdd: () => dispatch(actions.initializeAddMerchant()),
    onFetchSearchCounts: (search) => dispatch(actions.fetchSearchCounts(search))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MerchantNotFoundDialog)
